import axios from 'axios';
import { getIpAddress, getToken, getTokenWs, getUser } from 'src/utils/Common';

const SERVICE_SHOP_STORAGE_KEY = 'aronRotam:selectedServiceShop';

export const getSelectedServiceShop = () => {
  try {
    const value = sessionStorage.getItem(SERVICE_SHOP_STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const setSelectedServiceShop = (serviceShop) => {
  if (serviceShop?.id) {
    sessionStorage.setItem(SERVICE_SHOP_STORAGE_KEY, JSON.stringify(serviceShop));
  } else {
    sessionStorage.removeItem(SERVICE_SHOP_STORAGE_KEY);
  }
};

const aronRotamApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000
});

aronRotamApi.interceptors.request.use((config) => {
  const user = getUser() || {};
  const serviceShop = getSelectedServiceShop();

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${getToken() || ''}`,
    SessionToken: getToken() || '',
    SessionTokenWs: getTokenWs() || '',
    IpAddress: getIpAddress() || '',
    'Auth-UserId': user.UserId || user.OrganizationUserId || '',
    ...(serviceShop?.id
      ? { 'X-AronRotam-ServiceShopId': String(serviceShop.id) }
      : {})
  };

  return config;
});

export default aronRotamApi;
